import { walletInstance } from "../apiBase/instance";

export const AppConfig = {
    GetStreamUrl(): string {
        const base = 'https://api-wallet.paywithcrypto.io';
        return `${base}/api/transaction-temp/stream`;
    },
    GetReportDaily() {
        return walletInstance.get<any>(`api/transaction-temp/report/daily`);
    },
    GetReportMonth() {
        return walletInstance.get<any>(`api/transaction-temp/report/month`);
    },
    GetReportYear() { 
        return walletInstance.get<any>(`api/transaction-temp/report/year`);
    },
    GetReportAll() {
        return walletInstance.get<any>(`api/transaction-temp/report/all`);
    },
    CheckStatusLive() {
        return walletInstance.get<any>(`api/transaction-temp/status`);
    },
    DisableStream() {
        return walletInstance.post<any>(`api/transaction-temp/disable-web`);
    },  
    EnableStream() {
        return walletInstance.post<any>(`api/transaction-temp/enable-web`);
    },
}